import { render, staticRenderFns } from "./CompanyMultiRestaurantTabPackages.vue?vue&type=template&id=61c6cc41"
import script from "./CompanyMultiRestaurantTabPackages.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports